import React from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, Query, Mutation } from 'react-apollo';
import client from '../lib/apolloClient';
import ActionPlanSelection from '../components/ActionPlan/ActionPlanSelection';

const GET_ACTION_PLAN = gql`
  query GetActionPlanForCurrentUser {
    getCurrentUser {
      id
      action_plan {
        id
        current_sprint_starts_at
        current_sprint_ends_at
        items {
          id
          status
          cepa_category
          selected_for_sprint
          completed_at
          metadata
          task_template {
            key
            title
            description
            cepa_category
            completion_type
            completion_condition_key
          }
          created_from_assessment_question {
            id
            key
            section
            text
            cepa_category
          }
        }
      }
      triggering_events(limit: 1) {
        id
        event_type
        completed_at
        source
      }
    }
  }
`;

const START_OR_UPDATE_SPRINT = gql`
  mutation StartOrUpdateSprint($itemIds: [ID!]!, $durationDays: Int!) {
    start_or_update_sprint(item_ids: $itemIds, duration_days: $durationDays) {
      errors
      action_plan {
        id
        current_sprint_starts_at
        current_sprint_ends_at
        items { id selected_for_sprint }
      }
    }
  }
`;

const COMPLETE_MANUAL_ITEM = gql`
  mutation CompleteManualItem($id: ID!, $note: String) {
    complete_manual_item(action_plan_item_id: $id, note: $note) {
      errors
      action_plan_item { id status completed_at }
    }
  }
`;

const UPLOAD_PROOF = gql`
  mutation UploadProof($id: ID!, $documentId: ID!) {
    upload_proof(action_plan_item_id: $id, document_id: $documentId) {
      errors
      action_plan_item { id status completed_at }
    }
  }
`;

class ActionPlanSelectionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selected: [], durationDays: 14 };
  }

  toggleSelect = (id) => {
    this.setState((prev) => {
      const exists = prev.selected.includes(id);
      const next = exists ? prev.selected.filter((x) => x !== id) : prev.selected.concat(id);
      return { selected: next };
    });
  };

  render() {
    return (
      <ApolloProvider client={client}>
        <Query query={GET_ACTION_PLAN} fetchPolicy="cache-and-network" errorPolicy="all">
          {({ data, loading, error, refetch }) => (
            <Mutation mutation={START_OR_UPDATE_SPRINT}>
              {(startSprint, { loading: starting }) => (
                <Mutation mutation={COMPLETE_MANUAL_ITEM}>
                  {(completeManual, { loading: completing }) => (
                    <Mutation mutation={UPLOAD_PROOF}>
                      {(uploadProof, { loading: uploading }) => {
                        const items = (data && data.getCurrentUser && data.getCurrentUser.action_plan && data.getCurrentUser.action_plan.items) || [];
                        const events = (data && data.getCurrentUser && data.getCurrentUser.triggering_events) || [];
                        const latestEvent = events[0];

                        const onStartSprint = async () => {
                          if (this.state.selected.length === 0) return;
                          const res = await startSprint({ variables: { itemIds: this.state.selected, durationDays: this.state.durationDays } });
                          const errs = (res && res.data && res.data.start_or_update_sprint && res.data.start_or_update_sprint.errors) || [];
                          if (errs.length === 0) {
                            this.setState({ selected: [] });
                            refetch();
                          }
                        };

                        const onCompleteManual = async (id) => {
                          const res = await completeManual({ variables: { id } });
                          const errs = (res && res.data && res.data.complete_manual_item && res.data.complete_manual_item.errors) || [];
                          if (errs.length === 0) refetch();
                        };

                        const onUploadProof = async (id, documentId) => {
                          if (!documentId) return;
                          const res = await uploadProof({ variables: { id, documentId } });
                          const errs = (res && res.data && res.data.upload_proof && res.data.upload_proof.errors) || [];
                          if (errs.length === 0) refetch();
                        };

                        return (
                          <ActionPlanSelection
                            loading={loading || starting || completing || uploading}
                            error={error && error.message}
                            items={items}
                            latestEvent={latestEvent}
                            selectedIds={new Set(this.state.selected)}
                            durationDays={this.state.durationDays}
                            onDurationChange={(d) => this.setState({ durationDays: d })}
                            onToggleSelect={this.toggleSelect}
                            onStartSprint={onStartSprint}
                            onCompleteManual={onCompleteManual}
                            onUploadProof={onUploadProof}
                          />
                        );
                      }}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          )}
        </Query>
      </ApolloProvider>
    );
  }
}

export default ActionPlanSelectionContainer;


